// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__y-wOX","link":"Navbar_link__zGYRb"};